import React, { useState, useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import ShoppingCartOutlined from "@mui/icons-material/ShoppingCartOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { useMutation, useManualQuery } from "graphql-hooks";

import FloatingMenu from "./components/FloatingMenu";
import ProductCard from "./components/ProductCard";
import AlertPopup from "./components/AlertPopup";
import CommentDialog from "./components/CommentDialog";

import Avatar3 from "./assets/SearchResults/Avatars/Robert_Thompson.png";

import placeholderImage from "./assets/r3play-logo-sml.png";

import { PUBLISHED_OBJECT_LIST } from "./graphQL/all_objects_qry";

import { CREATE_COLLECTION_MUTATION, DELETE_COLLECTION_MUTATION } from "./graphQL/collection_qry";

export default function Dashboard() {
  const [floatMenuLeftMargin, setFloatMenuLeftMargin] = useState(0);
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);

    const typeMap = {
      toy: "Toys",
      video: "Videos",
      story: "Stories",
  };


  const [products, setProducts] = useState([]);

  // Set floating menu place based on screen size
  useEffect(() => {
    const handleResize = () => {
      setFloatMenuLeftMargin(window.innerWidth - 100);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);
  }, []);

  let userUuid = localStorage.getItem("userUuid") ? localStorage.getItem("userUuid") : null;

  const firstName = localStorage.getItem("firstName") || " ";
  const loggedUserName = localStorage.getItem("userName") || "";

  const [getObjectsData] = useManualQuery(
    PUBLISHED_OBJECT_LIST, {
    fetchPolicy: "network-only",
  });

  //remove from collection by sami
  const [confirmPopup, setConfirmPopup] = useState({
    open: false,
    productId: 0,
    title: "",
});
  
  //add to collection by sami
  const [successPopup, setSuccessPopup] = useState({
    open: false,
    productId: 0,
    title: "",
});

  //Sami
  const [createCollection] = useMutation(CREATE_COLLECTION_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [deleteCollection] = useMutation(DELETE_COLLECTION_MUTATION, {
    awaitRefetchQueries: true,
  });

  // Helper function to get video thumbnail from any platform
  const getVideoThumbnail = (videoUrl) => {
    if (!videoUrl) return "";

    // YouTube
    if (videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be")) {
      let videoId = "";
      if (videoUrl.includes("youtu.be/")) {
        videoId = videoUrl.split("youtu.be/")[1].split("?")[0];
      } else if (videoUrl.includes("youtube.com")) {
        const urlParams = new URLSearchParams(videoUrl.split("?")[1]);
        videoId = urlParams.get("v");
      }
      return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    }

    // Vimeo
    if (videoUrl.includes("vimeo.com")) {
      const videoId = videoUrl.split("/").pop().split("?")[0];
      return `https://vumbnail.com/${videoId}.jpg`;
    }

    // Dailymotion
    if (videoUrl.includes("dailymotion.com") || videoUrl.includes("dai.ly")) {
      let videoId = "";
      if (videoUrl.includes("dai.ly/")) {
        videoId = videoUrl.split("dai.ly/")[1].split("?")[0];
      } else {
        videoId = videoUrl.split("/video/")[1].split("?")[0];
      }
      return `https://www.dailymotion.com/thumbnail/video/${videoId}`;
    }

    // Default fallback - return empty or a placeholder
    return "";
  };


  

  const dashboardCards = [
    {
      title: "Toy",
      description: "List a toy for sale, trade, or donation.",
      icon: ShoppingCartOutlined,
      bgColor: "#04A15B",
      onClick: () => navigate("/toys-list"),
    },
    {
      title: "Story",
      description: "Share the memories behind your toys.",
      icon: AutoStoriesOutlinedIcon,
      bgColor: "#01579B",
      onClick: () => navigate("/my-stories"),
    },
    {
      title: "Video",
      description: "Showcase your collection with short clips.",
      icon: VideocamOutlinedIcon,
      bgColor: "#EFB561",
      onClick: () => navigate("/my-videos"),
    },
    {
      title: "My Work Area",
      description: "Manage your all activities in one place.",
      icon: PersonOutlineOutlinedIcon,
      bgColor: "#EF5658",
      onClick: () => navigate("/my-profile"),
    },
  ];

  
const setObjectList = async () => {    
    if (!userUuid) return;
    const {
      loading: loadingObjectListData,
      error: errorObjectListData,
      data: objectListData,
    } = await getObjectsData({
      variables: {
        userUuid: userUuid,
      },
    });
    
    if (!loadingObjectListData && objectListData && objectListData.publishedObjectList) { 
                  
      setProducts(
        objectListData.publishedObjectList
         .map((item, index) => ({      
          id: item.objectId ,
          userId: {
            userId: item.ownerInfo.id,
            userUuid: item.ownerInfo.userUuid,
            firstName: item.ownerInfo.firstName ,
            lastName: item.ownerInfo.lastName,
            username: item.ownerInfo.username,            
            avatarFileName: item.ownerInfo.avatarFileName,
            isFollowing: item.ownerInfo.isLoggedInUserFollowing,
            listings: item.ownerInfo.listings,
            soldToys: item.ownerInfo.soldToys,
            ratingNo: item.ownerInfo.ratingNo,
            ratingCount: item.ownerInfo.ratingCount,
            dateJoined: item.ownerInfo.dateJoined,
          },
          uuid: item.uuid,
          title: item.title,
          price: item.sellingPrice,
          oldPrice: item.originalPrice,
          category: item.category,
          contentType: typeMap[item.contentType] || "",
          shareUrl: `${window.location.origin}${item.shareUrl}`,
          img: item.contentType === 'video' ? getVideoThumbnail(item.image) || placeholderImage 
               : item.image,

          likes: item.likeNo,
          isLiked: item.isLiked,
          shares: item.shareNo,
          isInCollection: item.isInCollection,
          content: item.content,
          commentNo: item.commentNo,
          comments: item.comments,
          likedUsers: (item.likeUsers ?? []).map((userLike, index) => {
                  return {
                    id: userLike.userId.id,
                    username: userLike.userId.username,
                    avatar: userLike.userId.avatarFileName,
                    isFollowing: userLike.userId.isLoggedInUserFollowing }
                  }
                ),
        }))        
      ); 
      setIsLoaded(true); 
    } else {
      console.log("errorObjectListData: ", errorObjectListData);           
    };
  };

  useEffect(() => {
    (async () => setObjectList())();
  }, [userUuid]);
  
  const handleUserProfileNavigation = (user) => {
    // Navigate to user's public homepage
    navigate(`/user/${user.userUuid}/profile`);
  };

    const handleUserFollowUpdate = () => {
    // Update user data in products state
    setObjectList()
  }; 


  // Handle bookmark click to show confirmation popup
  const handleBookmarkClick = (productId, isInCollection, contentType) => {    
    const product = products.find((p) => p.id === productId);
        
    if(contentType === "Stories")
      contentType = "story"
    else if(contentType === "Videos")
      contentType = "video"
    else
      contentType = "toy"
    if (isInCollection) {
    // Show removal confirmation 
    setConfirmPopup({
      open: true,
      productId: productId,
      title: product ? product.title : "",
      contentType: contentType
    });
  } else {
    // Show add alert
    setSuccessPopup({
      open: true,
      productId: productId,
      title: product ? product.title : "",
      contentType: contentType
    }); 
   }  
  };

  const handleConfirmAdd = async () => {
    console.log("handleConfirmAdd");
    await createCollection({
      variables: {
        objectId: parseInt(successPopup.productId),
        contentType: successPopup.contentType,
      },
    });
    setSuccessPopup({ open: false,productId: 0, title: "" });
    console.log(successPopup.productId);
    console.log(successPopup.contentType);
    setProducts((prev) =>
      prev.map((product) =>
        product.id === successPopup.productId
          ? { ...product, isInCollection: !product.isInCollection }
          : product

      ));
    
};

  const handleConfirmRemove = async () => {
    console.log("handleConfirmRemove");
    await deleteCollection({
      variables: {
        objectId: parseInt(confirmPopup.productId),
        contentType: confirmPopup.contentType,
      },
    });

    setProducts((prev) =>
      prev.map((product) =>
        product.id === confirmPopup.productId
          ? { ...product, isInCollection: !product.isInCollection }
          : product

      ));
    setConfirmPopup({ open: false,productId: 0, title: "" });
};

  // Handle cancel action
  const handleCancelAction = () => {
    setConfirmPopup({ open: false,productId: 0, title: "" });
    setSuccessPopup({ open: false,productId: 0, title: "" });
  };

    // Handle share click to increment share count
  const handleShareClick = (productId) => {
    setObjectList((prev) =>
      prev.map((product) =>
        product.id === productId
          ? { ...product, shares: (product.shares || 0) + 1 }
          : product
      )
    );
  }; 



  return (
    <>
      <Box
        sx={{
          backgroundColor: "#F5F5F5",
          minHeight: "100vh",
          py: 8,
        }}
      >
        <Helmet>
          <title>R3PLAY - User Dashboard</title>
          <meta
            name="description"
            content="Manage your toys, track sales, and view performance insights"
          />
          <meta
            property="keywords"
            content="User dashboard, toy management, toy analytics"
          />
        </Helmet>

        <Box
          sx={{
            maxWidth: "1440px",
            px: "100px",
            "@media (max-width: 856px)": {
              px: "16px",
              maxWidth: "640px",
            },
          }}
        >
          {/* Welcome Section */}
          <Box sx={{ mb: 4 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 0.5,
                mt: 1,
                mb: 2,
                "@media (min-width: 1024px)": {
                  display: "none",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "rgba(0, 0, 0, 0.87)",
                }}
              >
                Today's Date:
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "rgba(0, 0, 0, 0.6)",
                }}
              >
                {new Date().toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                mb: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: "36px",
                  fontWeight: 600,
                  color: "#000",
                }}
              >
                Hi {firstName}!
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 0.5,
                  mt: 1,
                  "@media (max-width: 1023px)": {
                    display: "none",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: "rgba(0, 0, 0, 0.87)",
                  }}
                >
                  Today's Date:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: "rgba(0, 0, 0, 0.6)",
                  }}
                >
                  {new Date().toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </Typography>
              </Box>
            </Box>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#000",
                mb: 0.5,
              }}
            >
              Welcome back to your toy universe.
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "regular",
                color: "rgba(0, 0, 0, 0.6)",
              }}
            >
              Explore, sell, buy, or donate toys — all in one joyful space.
            </Typography>
          </Box>

          {/* Dashboard Cards */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
              justifyContent: "flex-start",
            }}
          >
            {dashboardCards.map((card, index) => (
              <Box
                key={index}
                sx={{
                  width: "298px",
                  height: "126px",
                  background:
                    "linear-gradient(180deg, #FFFFFF 0%, #FFF6F2 100%)",
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                  borderRadius: "16px",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  "@media (max-width: 856px)": {
                    flexDirection: "column",
                    width: "171px",
                    height: "178px",
                    gap: "16px",
                    justifyContent: "center",
                    alignItems: "center",
                    py: 2,
                    px: 1,
                  },
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    width: "58px",
                    height: "58px",
                    backgroundColor: card.bgColor,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <card.icon sx={{ fontSize: 28, color: "#fff" }} />
                </Box>

                {/* Text */}
                <Box
                  sx={{
                    flex: 1,
                    "@media (max-width: 856px)": { textAlign: "center" },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "24px",
                      fontWeight: 600,
                      color: "#000",
                      mb: 0.5,
                      lineHeight: 1.2,
                      "@media (max-width: 856px)": {
                        fontSize: "20px",
                      },
                    }}
                  >
                    {card.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#666",
                      lineHeight: 1.5,
                      "@media (max-width: 856px)": {
                        fontSize: "12px",
                      },
                    }}
                  >
                    {card.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          {/* Popular on R3PLAY Section */}
          <Box sx={{ pt: 6 }}>
            <Typography
              sx={{
                fontSize: "24px",
                fontWeight: 600,
                color: "#000",
                mb: 1,
              }}
            >
              Popular on R3PLAY
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#000",
              }}
            >
              Explore a lively mix of toys, stories, and videos shared by our
              growing community of collectors and creators.
            </Typography>
          </Box>

          {/* Popular Products Grid */}
          {!isLoaded ? (
            <Box p={4} textAlign="center">Loading...</Box>
              ) 
              : isLoaded && products.length === 0 ? 
              (
                <Box p={4} textAlign="center" color="gray">
                  No Collections found
                </Box>
              ) : (
              <>

            <Box sx={{ pt: 3 }}>
              <Box
                sx={{
                  maxWidth: "1800px",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "24px",
                  width: "100%",
                  "@media (max-width: 833px)": {
                    justifyContent: "center",
                  },
                }}
              >
                {products.map((product) => (
                  <Box
                    key={product.id}
                    sx={{
                      width: "288px",
                      position: "relative",
                      overflow: "visible",
                      "@media (max-width: 856px)": {
                        mb: "24px",
                      },
                    }}
                   >
                  
                    <ProductCard
                      key={`${product.id}-${product.isLiked}-${product.likes}-${product.userId.isFollowing}-${product.isInCollection}`}
                      p={product}
                      onBookmarkClick={handleBookmarkClick}
                      onUserProfileNavigation={handleUserProfileNavigation}
                      onFollowToggle={handleUserFollowUpdate}                      
                      onShareClick={handleShareClick}                     
                    />
                  </Box>
                ))}
              </Box>            
          </Box>
          </>
          )}
        </Box>
      </Box>

       {/* Alert Popup for add collection actions */} 
      <AlertPopup
        open={successPopup.open}
        title={`Item "${successPopup.title}" is added to your collection.`}
        cancelText=""
        confirmText="OK"
        onConfirm={handleConfirmAdd}
        onClose={() => setSuccessPopup({ open: false, productId: 0,title: "" })}
      />

      {/* Alert Popup for remove collection actions */} 
      <AlertPopup
        open={confirmPopup.open}
        title={`Are you sure you want to remove "${confirmPopup.title}" from your collection?`}
        confirmText="Yes, Remove"
        cancelText="Cancel"
        onConfirm={handleConfirmRemove}
        onCancel={() => setConfirmPopup({ open: false, productId: 0,title: "" })}
        onClose={() => setConfirmPopup({ open: false, productId: 0,title: "" })}
      />     



      <FloatingMenu left={floatMenuLeftMargin} />
    </>
  );
}
